module.exports = __webpack_public_path__ + "img/close_white.79843655.svg";